import { registerPlugin } from "@mailonline/dmg-ads-core/src/plugin-registry";
import { removeUndefinedProps } from '@mailonline/dmg-ads-core/src/ads-utils/ObjectUtils'
import { get as getConfig } from '@mailonline/dmg-ads-core/src/config'

const _collectTargeting = (broker, slot, gptSlot, getTagsNum) =>
  new Promise((resolve, reject) => {
    const COLLECTION_TIMEOUT = getConfig('auction.maxTime', 2000)
    const tags = []
    const stream = broker.openStream({
      message: ['get tags', { slot, gptSlot, getTagsNum, timeout: COLLECTION_TIMEOUT - 100 }],
      timeout: COLLECTION_TIMEOUT,
      controlHandler: ({ type, ...data }) => {
        broker.emit('auction event', slot.pos, type, data)
      }
    })
    stream
      .on('data', data => {
        tags.push(data)
      })
      .on('end', () => {
        broker.emit('auction event', slot.pos, 'end')
        resolve(tags)
      })
      .on('error', err => reject(err))
  })

function formTags (_tags, log) {
  log('formTags', _tags)
  const tags = _tags.flat().map(t => t?.targeting || t || {})
  return removeUndefinedProps(tags.reduce((acc, tag) => ({ ...acc, ...(Array.isArray(tag) && tag.reduce((acc, t) => ({ ...acc, ...t }), {}) || tag) }), {}))
}

async function collectTargeting (broker, log, slot, gptSlot, getTagsNum) {
  const _tags = await _collectTargeting(broker, slot, gptSlot, getTagsNum)
  const bids = _tags.filter(t => t.bids).flat()
  const tagsBasedOnTags = await broker.invokeAll('get tags based on tags', _tags)
  const targeting = { ...formTags(_tags, log), ...tagsBasedOnTags.reduce((acc, tag) => ({ ...acc, ...tag }), {}) }
  return [targeting, bids]
}

registerPlugin('slotController', { ccpa: { enabledIfDissent: true }, gdpr: { enabledIfDissent: true }, run })

function run({ broker, log }) {
  let getTagsNum = 0

  const collectTargetingAndRequestAd = (id, pos, slotDefinition, gptSlot) => {
    broker.emit(`start bidding for pos: ${pos}`)
    getTagsNum++
    const _getTagsNum = getTagsNum
    const { dfpPos } = slotDefinition
    return collectTargeting(broker, log, slotDefinition, gptSlot, getTagsNum)
      .then(([targeting, bids]) => {
        log(`bid targeting for pos: ${pos}`, targeting, bids)
        broker.emit('bidding ended', pos, { getTagsNum: _getTagsNum, slot: gptSlot, tags: bids, dfpPos })
        return targeting
      })
  }

  broker.on('slot defined', slotDefinition => {
    const { pos, id, onlyRefreshIfViewed = true } = slotDefinition
    broker.once('slot created', id, (gptSlots) => {
      let refreshCount = slotDefinition.refreshCount || 0
      broker.on('refresh ads', pos, ({ reason: refreshReason }) => {
        refreshCount++
        const pTargeting = collectTargetingAndRequestAd(id, pos, slotDefinition, gptSlots[0])
        pTargeting.then(targeting => {
          log('refresh targeting:', targeting)
          broker.emit('refresh slot', gptSlots, id, { ...targeting, refreshCount, refreshReason, pos })
        })
      })
      const pTargeting = collectTargetingAndRequestAd(id, pos, slotDefinition, gptSlots[0])
      pTargeting.then(targeting => {
        broker.emit('request ad', gptSlots, id, { ...targeting, pos })
      })
    })

    if (slotDefinition.refreshInterval) {
      broker.once('ad rendered', pos, () => {
        if (pos.endsWith('-oop')) return
        broker.emit('setup ad refresh', {
          pos,
          id,
          interval: slotDefinition.refreshInterval,
          activeViewSlot: onlyRefreshIfViewed
        })
      })
    }
    log('slot defined, creating slot', slotDefinition)
    broker.emit('create slot', slotDefinition)
  })
}
